import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { Link } from '@mui/material';
import NoticeFileList from '../../../components/dashboard/notice/NoticeFileList';
import { listNoticeFiles, unloadNoticeFiles } from '../../../modules/dashboardModule/noticeFiles';
import * as fileApi from '../../../lib/api/file';

const NoticeFileListContainer = ({ notice }) => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();

    //redux selection
    const { files, error, loading } = useSelector(
        ({ dashboardModule, loading }) => ({
            files: dashboardModule.noticeFiles.files,
            error: dashboardModule.noticeFiles.error,
            loading: loading['dashboard/LIST_NOTICE_FILES'],
        }),
    );
    //useEfffect

    useEffect(() => {
        if (notice) {
            dispatch(listNoticeFiles('notice', notice.wrUuid));
        }

        //언마운트될때 리덕스에서 파트너 데이터 초기화
        return () => {
            dispatch(unloadNoticeFiles());
        };
    }, [notice]);

    // 백엔드 API를 통한 파일 다운로드
    const handleDownload = async (fileUuid, fileNm) => {
        try {
            const response = await fileApi.downloadFile(fileUuid);
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileNm;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
            }, 60000);
            a.remove();
        } catch (err) {
            console.error('Download error:', err);
            enqueueSnackbar('파일 다운로드에 실패했습니다.', {
                variant: 'error',
            });
        }
    };

    const columns = useMemo(
        () => [
            {
                field: 'id',
                headerName: 'ID',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileUuid',
                headerName: '파일코드',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileTyp',
                headerName: '파일타입',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileAttrVal1',
                headerName: '공지ID',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileAttrVal2',
                headerName: '파일 타입',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileAttrVal3',
                headerName: '파일참고2',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileNm',
                headerName: '파일명',
                minWidth: 300,
                flex: 1,
                editable: false,
                filterable: false,
                renderCell: (params) => (
                    <Link
                        component="button"
                        variant="body2"
                        onClick={() => handleDownload(params.row.fileUuid, params.row.fileNm)}
                        sx={{ cursor: 'pointer', textAlign: 'left' }}
                    >
                        {params.value}
                    </Link>
                ),
            },
            {
                field: 'fileDesc',
                headerName: '참고사항',
                minWidth: 400,
                flex: 1,
                type: 'string',
                editable: false,
            },
        ],
        [handleDownload],
    );

    return (
        <div>
            <NoticeFileList
                columns={columns}
                files={files}
                error={error}
                loading={loading}
                columnVisibilityModel={{
                    id: false,
                    fileUuid: false,
                    fileTyp: false,
                    fileAttrVal1: false,
                    fileAttrVal2: false,
                    fileAttrVal3: false,
                  }}
          
            />
        </div>
    )
}

export default NoticeFileListContainer